import { useMutation } from '../services/NetworkManager';
import { NetworkManager } from '../services';

export type SipFrequency = 'DAILY' | 'WEEKLY' | 'MONTHLY';

export type SipSourceType = 'SILVER_SAVING' | 'GOLD_SAVING';

export type ValidateSipSubscriptionPayload = {
  userId: number;
  recurringAmount: number;
  subscriptionFrequency: SipFrequency;
  sourceType: SipSourceType;
  firstChargeDate: string;
  phone: string;
  frequencyNote?: string;
};

export type ValidateSipSubscriptionResponse = {
  isValid?: boolean;
  message?: string;
};

export function validateSipSubscription(payload: ValidateSipSubscriptionPayload) {
  return NetworkManager.Call({
    method: 'post',
    path: NetworkManager.PATH.validateSipSubscription,
    data: payload,
  });
}

export default function useValidateSipSubscription() {
  const mutation = useMutation(validateSipSubscription);

  return {
    validate: mutation.mutate,
    validateAsync: mutation.mutateAsync,
    data: mutation.data?.data as ValidateSipSubscriptionResponse | undefined,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
}
